import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../../EmptyFragment';
import { T } from '../../../../../Translations';
import StarIcon from '../../../../Cutesies/StarIcon';
import LearningCollectionEditStore from '../../Edit/Store';
import { browseAllContext } from '../../Types';
import OnDemandCustomizeExperiences from './OnDemandCustomizeExperiences';

interface Props {
  store: LearningCollectionEditStore;
}

const BrowseAllExperiences: React.FC<Props> = ({ store }) => {
  const browseAllExperiences = store.onDemandExperienceStores;
  return when(store.browseAll, true)
    .map(() => (
      <OnDemandCustomizeExperiences
        store={store}
        openByDefault={false}
        titleIcon={<StarIcon />}
        title={{ kind: 'already-translated-text', text: 'Essentials Catalog' }}
        countDisplay={
          <T
            kind="Includes {{includedExperienceCount}} of {{totalExperienceCount}} programs"
            includedExperienceCount={browseAllExperiences.length}
            totalExperienceCount={
              browseAllExperiences.length +
              store.deletedOnDemandExperienceStores(browseAllContext()).length
            }
          />
        }
      />
    ))
    .getOrElse(emptyFragment);
};

export default observer(BrowseAllExperiences);
